import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "/node_modules/aos/dist/aos.css";
import "react-accessible-accordion/dist/fancy-example.css";
import "swiper/css";
import "swiper/css/bundle";
import "./index.css";
import "./styles/css/animate.min.css"
import "./styles/css/boxicons.min.css"
import "./styles/css/flaticon.css"
import "aos/dist/aos.css";
import './styles/css/style.css'
import './styles/css/responsive.css'
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
